var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h31v31H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.542 27.125H6.458a2.583 2.583 0 0 1-2.583-2.583V6.458a2.583 2.583 0 0 1 2.583-2.583h18.084a2.583 2.583 0 0 1 2.583 2.583v18.084a2.583 2.583 0 0 1-2.583 2.583zM11.625 9.042v2.583M11.625 15.5v6.458M19.375 9.042V15.5M19.375 19.375v2.583",
    stroke: "#323232",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.917 15.5h-2.584a1.292 1.292 0 0 1-1.291-1.292v-1.291c0-.713.578-1.292 1.291-1.292h2.584c.713 0 1.291.579 1.291 1.292v1.291c0 .713-.578 1.292-1.291 1.292zM20.667 19.375h-2.584a1.292 1.292 0 0 1-1.291-1.292v-1.291c0-.713.578-1.292 1.291-1.292h2.584c.713 0 1.291.579 1.291 1.292v1.291c0 .713-.578 1.292-1.291 1.292z",
    stroke: "#323232",
    strokeWidth: 1.95,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.c36f3d2b2f353391462aa476fe0d4135.svg";
export { ForwardRef as ReactComponent };